import { useState, useEffect } from "react";
import { ArrowUpRight } from "lucide-react";

export default function FloatingRegister() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => document.querySelector("#register")?.scrollIntoView({ behavior: "smooth" })}
      data-testid="floating-register-btn"
      className="lg:hidden fixed bottom-20 right-5 z-[60] bg-crimson text-white font-semibold text-sm px-5 py-3.5 shadow-lg shadow-crimson/30 flex items-center gap-2 active:scale-95 transition-transform"
    >
      Register <ArrowUpRight size={16} />
    </button>
  );
}
